<mat-form-field class="w-100" [appearance]="appearance()" subscriptSizing="dynamic">
  <mat-label>{{ label() | translate }}</mat-label>
  @if (type() !== 'textarea') {
    <input
      matInput
      [id]="id() ? 'input-' + id() : ''"
      [placeholder]="placeholder()"
      [formControl]="formControlRef()"
      [mask]="mask()"
      [prefix]="prefix()"
      [type]="type()"
      [required]="required()"
      [attr.autocomplete]="autocomplete()"
      [dropSpecialCharacters]="dropSpecialCharacters()"
      (input)="onInput($event)"
    />
  } @else {
    <textarea
      matInput
      [id]="id() ? 'input-' + id() : ''"
      [placeholder]="placeholder()"
      [formControl]="formControlRef()"
      [required]="required()"
      [attr.autocomplete]="autocomplete()"
      rows="4"
    ></textarea>
  }

  @if (icon()) {
    <button matSuffix mat-icon-button type="button" tabindex="-1">
      <mat-icon>{{ icon() }}</mat-icon>
    </button>
  }

  @if (formControlRef().hasError('invalidCnpj')) {
    <mat-error>{{ 'CNPJ inválido' }}</mat-error>
  }

  <mat-hint>
    @if (hint()) {
      {{ hint() }}
    }
    <ng-content select="[slot=hint]"> </ng-content>
  </mat-hint>
</mat-form-field>
